/* eslint-disable max-len */
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import transactionsFields from '../../../fields/transactionsFields';
import { Badge } from '@/common-utils/components/ui/badge';
import RenderBankCode from '@/app/modules/contracts/components/bankCode/RenderBankCode';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import RenderApplication from '@/app/modules/contracts/components/application/RenderApplication';
import RenderInternationalizedAmount from '@/common-utils/components/renders/currency/RenderInternationalizedAmount';
import RenderOriginApplication from '@/app/modules/terminals/components/renders/originApplication/RenderOriginApplication';
import RenderCbLogo from '@/app/modules/terminals/components/renders/cbLogo/RenderCbLogo';
import RenderAuthorizationCode from '@/app/modules/terminals/components/renders/authorizationCode/RenderAuthorizationCode';
import DropdownTransactionsActionsRow from '../../dropdown/DropdownTransactionsActionsRow';
import EVENT_TYPE from '@/app/modules/terminals/enums/EventType';
import AUTHORIZATION_CODE_RESULT from '@/app/modules/terminals/enums/AuthorizationCodeResult';
import TRANSACTION_TYPE from '@/app/modules/terminals/enums/TransactionType';
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';
import RenderCardProduct from '@/app/modules/terminals/components/renders/product/RenderCardProduct';

export const columnsTransactionsId = 'transactions';

export const columnsTransactions = (headerPackage) => {

    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsTransactionsId),
        generateColumnDefByField({
            field: transactionsFields.ORIGIN_APPLICATION,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderOriginApplication originApplication={cell.getValue(transactionsFields.ORIGIN_APPLICATION.key)} />
            )
        }),
        generateColumnDefByField({
            field: transactionsFields.UUID,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                return cell && cell.row.original &&
                    <DropdownTransactionsActionsRow
                        transaction={cell.row.original}
                        setLaunchRefetch={headerPackage.setLaunchRefetch}
                    />;
            },
            show: !headerPackage.selectionMode
        }),

        generateColumnDefByField({
            field: transactionsFields.LOCAL_TRANSACTION_DATE_TIME,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(transactionsFields.LOCAL_TRANSACTION_DATE_TIME.key)} />
            )
        }),
        generateColumnDefByField({
            field: transactionsFields.EVENT_TYPE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const eventType = EVENT_TYPE[cell.getValue(transactionsFields.EVENT_TYPE.key)];
                return (
                    eventType &&
                    <Badge entity={eventType.entity} namespace={eventType.namespace} variant={eventType.variant} />
                );
            }
        }),
        generateColumnDefByField({
            field: transactionsFields.APPLICATION,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderApplication applicationCode={cell.getValue(transactionsFields.APPLICATION.key)} />
            )
        }),
        generateColumnDefByField({
            field: transactionsFields.CONTRACT,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: transactionsFields.POS_TERMINAL.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: transactionsFields.RANK,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: transactionsFields.BANK_CODE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderBankCode bankCode={cell.getValue(transactionsFields.BANK_CODE.key)} />
            )
        }),
        generateColumnDefByField({
            field: transactionsFields.AMOUNT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const currency = getObjectAttributeFromStringKey(
                    cell.row.original,
                    generateNestedFieldAccessor(transactionsFields.CURRENCY)
                );
                return (
                    cell &&
                    <RenderInternationalizedAmount amount={cell.getValue(transactionsFields.AMOUNT.key)} currency={currency} />
                );
            }
        }),
        generateColumnDefByField({
            field: transactionsFields.TYPE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const transactionType = TRANSACTION_TYPE[cell.getValue(transactionsFields.TYPE.key)];
                return (
                    transactionType &&
                    <Badge entity={transactionType.entity} namespace={transactionType.namespace} variant={transactionType.variant} />
                );
            }
        }),
        generateColumnDefByField({
            field: transactionsFields.AUTHORIZATION_CODE_RESULT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const status = AUTHORIZATION_CODE_RESULT[cell.getValue(transactionsFields.AUTHORIZATION_CODE_RESULT.key)];
                return (
                    cell &&
                    <Badge entity={status.entity} namespace={status.namespace} variant={status.variant} />
                );
            }
        }),
        generateColumnDefByField({
            field: transactionsFields.AUTHORIZATION_CODE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderAuthorizationCode authorizationCode={cell.getValue(transactionsFields.AUTHORIZATION_CODE.key)} />
            )
        }),
        generateColumnDefByField({
            field: transactionsFields.PAN,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <small>{cell.getValue(transactionsFields.PAN.key)}</small>
            )
        }),
        generateColumnDefByField({
            field: transactionsFields.EXPIRATION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(transactionsFields.EXPIRATION_DATE.key)} noDay noRelative noTime />
            )
        }),
        generateColumnDefByField({
            field: transactionsFields.AUTHORIZATION_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: transactionsFields.CARD_DETAILS.TYPE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderCbLogo cardType={cell.getValue(transactionsFields.CARD_DETAILS.TYPE.key)} />
            )
        }),
        generateColumnDefByField({
            field: transactionsFields.CARD_DETAILS.PRODUCT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                if (cell && cell.getValue(transactionsFields.CARD_DETAILS.PRODUCT.key)) {
                    const cardType = getObjectAttributeFromStringKey(
                        cell.row.original,
                        generateNestedFieldAccessor(transactionsFields.CARD_DETAILS.TYPE)
                    );
                    return (
                        <RenderCardProduct cardType={cardType} cardProduct={cell.getValue(transactionsFields.CARD_DETAILS.PRODUCT.key)} />
                    );
                } else {
                    return <div className='text-center align-middle'>{'-'}</div>;
                }
            }
        }),
        generateColumnDefByField({
            field: transactionsFields.RECONCILIATION_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: transactionsFields.POS_REMITTANCE_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: transactionsFields.FILE_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: transactionsFields.LEGAL_NAME,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: transactionsFields.REGISTRATION_NUMBER,
            headerPackage: headerPackage
        })
    ]).filter(col => !!col);
};